
import { createSlice } from '@reduxjs/toolkit'
import { Memberlist ,UpgradePlan,DegradePlan,MembershipPlanList} from '../api/MembershipApi'

const initialState = {
    membership_list: [],
    MembershiplanList:[],
    loading:false,
}

export const MembershipSlice = createSlice({
  name: 'MembershipSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

    // reducer for member list
      builder.addCase(Memberlist.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(Memberlist.fulfilled , (state, action) => {
       
        state.membership_list=action.payload;
        state.loading = false;
      })
      builder.addCase(Memberlist.rejected, (state, action) => {
        state.loading = false;
      
      })
    
      // reducer for upgrade
      builder.addCase(UpgradePlan.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(UpgradePlan.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(UpgradePlan.rejected, (state, action) => {
        state.loading = false;
      })

      // reducer for DegradePlan
      builder.addCase(DegradePlan.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(DegradePlan.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(DegradePlan.rejected, (state, action) => {
        state.loading = false;
      })
    
      // Memebership plan List
      builder.addCase(MembershipPlanList.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(MembershipPlanList.fulfilled , (state, action) => {
       
        state.MembershiplanList=action.payload;
        state.loading = false;
      })
      builder.addCase(MembershipPlanList.rejected, (state, action) => {
        state.loading = false;
      
      })
  },

})



export default MembershipSlice.reducer 